import { ORDER_STATUS, OrderStatus } from './status.constants';

export function getOrderStatusName(status: OrderStatus): string {
  switch (status) {
    case ORDER_STATUS.PROCESSED:
    case ORDER_STATUS.PROCESSED_ALT:
      return "Processed";
    case ORDER_STATUS.CANCELED:
    case ORDER_STATUS.CANCELED_ALT:
      return "Canceled";
    case ORDER_STATUS.UNDER_REVIEW:
      return "Under review";
    case ORDER_STATUS.PROCESSING:
      return "Processing";
    case ORDER_STATUS.REVISION_IN_PROGRESS:
      return "Revision in Progress";
    case ORDER_STATUS.REJECTED:
      return "Rejected";
    case ORDER_STATUS.COMPLETED:
      return "Completed";
    case ORDER_STATUS.COMPLETEDMANUALLY:
        return "Completed";  
    default:
      return "In processing";
  }
}